// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7e57398d","977":"262c9bc4"}[chunkId] + ".chunk.js";
};